var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkipLoaderTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 771 253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "ROLL OF DUMPSTER"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "SKIP LOADER"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M341.1 164.5h19.5",
    "data-name": "Line 64"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 2.513,
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.5 100.8v-2.6H215",
    "data-name": "Path 96"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "4.904 4.904",
    d: "M210.1 98.2H36",
    "data-name": "Line 65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 98.2H31v2.6",
    "data-name": "Path 97"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "5.031 5.031",
    d: "M31 105.8v35.9l36.6 37.1",
    "data-name": "Path 98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.4 180.6 1.8 1.8h2.5",
    "data-name": "Path 99"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "4.811 4.811",
    d: "M78.5 182.4h93.8",
    "data-name": "Line 66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.7 182.4h2.5l1.8-1.8",
    "data-name": "Path 100"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "5.038 5.038",
    d: "m182.5 177.1 35-35.4v-38.4",
    "data-name": "Path 101"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 74",
    transform: "translate(-12.5 -33.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M414.7 186.1h146.2v-24.4",
    "data-name": "Path 102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M352.3 186.1h22",
    "data-name": "Line 67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M311.9 186.1h-18.4a4.8 4.8 0 0 1-4.8-4.8v-8.1a4.8 4.8 0 0 1 4.8-4.8h267.3V89.7a6.7 6.7 0 0 1 6.7-6.7H619a6.8 6.8 0 0 1 5.8 3.3l31.2 53a12.494 12.494 0 0 1 1.8 6.5v45.6a6.7 6.7 0 0 1-6.7 6.7h-33.6",
    "data-name": "Path 103"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M560.9 186.1v4.7a6.018 6.018 0 0 0 6 6h7.5",
    "data-name": "Path 104"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 30",
    transform: "translate(574.3 172.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 31",
    transform: "translate(372.7 172.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 32",
    transform: "translate(310.3 172.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 33",
    transform: "translate(584.4 182.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 34",
    transform: "translate(382.8 182.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 35",
    transform: "translate(320.4 182.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 5.9,
    r: 5.9,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 36",
    transform: "translate(459 103.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m392.1 168.4 71.3-53.5",
    "data-name": "Line 68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m465.5 103.5-28.2-37.8a3.913 3.913 0 0 0-5.6-.8 4.017 4.017 0 0 0-.8 5.7l28.3 37.4",
    "data-name": "Path 105"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m379.6 168.4 79.6-60.5",
    "data-name": "Line 69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M640.5 112.9h-33.4a6.7 6.7 0 0 0-6.7 6.7v13.5a6.7 6.7 0 0 0 6.7 6.7h49.2",
    "data-name": "Path 106"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 2.513,
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.6 85.1h-2.5",
    "data-name": "Line 70"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "5.053 5.053",
    d: "M434 85.1H295",
    "data-name": "Line 71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5 85.1H290v2.5",
    "data-name": "Path 107"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "5.031 5.031",
    d: "M290 92.7v35.9l36.6 37.1",
    "data-name": "Path 108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.4 167.5 1.7 1.8h2.5",
    "data-name": "Path 109"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "4.811 4.811",
    d: "M337.4 169.3h93.9",
    "data-name": "Line 72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.7 169.3h2.5l1.7-1.8",
    "data-name": "Path 110"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "5.038 5.038",
    d: "m441.5 163.9 35-35.3V90.2",
    "data-name": "Path 111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.5 87.6v-2.5H474",
    "data-name": "Path 112"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "5.906 5.906",
    d: "M468.1 85.1h-8.9",
    "data-name": "Line 73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.3 85.1h-2.6",
    "data-name": "Line 74"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.351,
    d: "M427.6 54.2c-6.5-2.7-8.2 6.5-2.1 6 4.6-.4 5.9 4.6 5.9 4.6",
    "data-name": "Path 113"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.5 6.4v165.9",
    "data-name": "Line 75"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "M0 7.7 4.5 0 9 7.7Z",
    "data-name": "Path 114"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m0 171 4.5 7.7L9 171Z",
    "data-name": "Path 115"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M30.9 204.6h184.6",
    "data-name": "Line 76"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m32.2 209.1-7.8-4.5 7.8-4.5Z",
    "data-name": "Path 116"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m214.2 209.1 7.8-4.5-7.8-4.5Z",
    "data-name": "Path 117"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M280.7 204.6h356.7",
    "data-name": "Line 77"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m282 209.1-7.7-4.5 7.7-4.5Z",
    "data-name": "Path 118"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m636.1 209.1 7.8-4.5-7.8-4.5Z",
    "data-name": "Path 119"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m671.5 190.4 28.5-29.2",
    "data-name": "Line 78"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m675.7 192.6-8.7 2.5 2.2-8.7Z",
    "data-name": "Path 120"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m702.3 165.3 2.2-8.7-8.7 2.5Z",
    "data-name": "Path 121"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 124",
    transform: "translate(-1121.595 -6529.798)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 33,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.798 6556.71a2 2 0 0 1 2.204-.8l20.574 5.853a2 2 0 0 1 .132 3.806l-32.568 11.848a2 2 0 0 1-2.344-3Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "H,H m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(38.072 33.965)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "H,H m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-1064.155 -6323.639)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M123.706 211.854a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051h-13.828a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "C,C m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(95.406 243.361)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "C,C m")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-736.155 -6323.358)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M451.706 212.135a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051h-13.828a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "L,L m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(426.406 243.642)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "L,L m")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(-459.623 -6355.734)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.814 6547.788a2 2 0 0 1 .802 2.204l-5.854 20.574a2 2 0 0 1-3.806.132l-11.848-32.568a2 2 0 0 1 3-2.344Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "W,W m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(696.377 211.266)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "W,W m"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipLoaderTruck);
export default __webpack_public_path__ + "static/media/SkipLoaderTruck.32023c2111e208434a336744f6b63e46.svg";
export { ForwardRef as ReactComponent };